(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aara-cart-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aara-cart-delivery')) {
  customElements.define('aara-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      this.renderTotal(Number(this.dataset.total), this.dataset.currency);
      this.onVisible = () => { if (!document.hidden) this.updateDates(); };
      this.onPageShow = () => { this.updateDates(); this.refreshCart(); };
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('pageshow', this.onPageShow);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const cart = event.cartData;
          if (cart && Number.isFinite(cart.total_price)) this.renderTotal(cart.total_price, cart.currency || this.dataset.currency);
          else this.refreshCart();
        });
      }
    }
    disconnectedCallback() {
      clearTimeout(this.dateTimer);
      this.unsubscribe?.();
      this.controller?.abort();
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    updateDates() {
      clearTimeout(this.dateTimer);
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-US', { timeZone:'Asia/Dubai', year:'numeric', month:'numeric', day:'numeric' }).formatToParts(now);
      const value = (type) => Number(parts.find((part) => part.type === type).value);
      const day = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      const nextDay = (date) => { do { date.setUTCDate(date.getUTCDate() + 1); } while (date.getUTCDay() === 0); return date; };
      const first = nextDay(new Date(day));
      const last = nextDay(new Date(first));
      const formatter = new Intl.DateTimeFormat('en-US', { timeZone:'UTC', weekday:'short', month:'short', day:'numeric' });
      this.querySelector('[data-dates]').textContent = formatter.format(first) + ' – ' + formatter.format(last);
      this.querySelector('[data-estimate]').hidden = false;
      // Dubai is UTC+4 all year. Refresh at its next midnight, also after tab wake-up.
      const nextMidnight = day.getTime() + 86400000 - 4 * 3600000;
      this.dateTimer = setTimeout(() => this.updateDates(), Math.max(1000, nextMidnight - now.getTime() + 100));
    }
    renderTotal(total, currency) {
      if (!Number.isFinite(total)) return;
      this.dataset.total = String(total);
      this.dataset.currency = currency;
      this.querySelector('[data-free-delivery]').hidden = currency !== 'AED';
      const remaining = Math.max(0, 19900 - total);
      const amount = new Intl.NumberFormat('en-AE', { minimumFractionDigits:remaining % 100 ? 2 : 0, maximumFractionDigits:2 }).format(remaining / 100);
      const message = remaining ? this.dataset.remaining.replace('__AMOUNT__', amount) : this.dataset.unlocked;
      this.querySelector('[data-message]').textContent = message;
      const detail = this.querySelector('[data-detail]');
      detail.textContent = this.dataset.add.replace('__AMOUNT__', amount);
      detail.hidden = remaining === 0;
      this.querySelector('[data-fill]').style.width = Math.max(0, Math.min(100, total / 19900 * 100)) + '%';
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.max(0, Math.min(199, total / 100))));
    }
    async refreshCart() {
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { signal:this.controller.signal, headers:{ Accept:'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected) this.renderTotal(cart.total_price, cart.currency);
      } catch (_) { /* Preserve the server-rendered cart display if a refresh fails. */ }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aara-signup-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aara-signup-popup')) {
    customElements.define('aara-signup-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.pendingKey = 'aara-welcome-pending-v1';
        this.seenKey = 'aara-welcome-seen-v1';
        this.hasSeen = () => {
          try { if (localStorage.getItem(this.seenKey) === '1') return true; } catch {}
          try { return sessionStorage.getItem(this.seenKey) === '1'; } catch { return false; }
        };
        this.rememberSeen = () => {
          if (this.preview) return;
          try { localStorage.setItem(this.seenKey, '1'); } catch {}
          try { sessionStorage.setItem(this.seenKey, '1'); } catch {}
        };
        this.result = this.querySelector('[data-signup-result]').dataset.signupResult;
        this.preview = new URLSearchParams(window.location.search).get('aara_signup_preview') === '1';
        this.readPending = () => { try { return Number(sessionStorage.getItem(this.pendingKey) || 0); } catch { return 0; } };
        this.writePending = (value) => { try { sessionStorage.setItem(this.pendingKey, String(value)); } catch {} };
        this.onCloseClick = (event) => { if (event.target.closest('[data-signup-close]')) this.dialog.close(); };
        this.onSubmit = () => this.writePending(Date.now());
        this.onBackdrop = (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        };
        this.addEventListener('click', this.onCloseClick);
        this.dialog.addEventListener('click', this.onBackdrop);
        this.form.addEventListener('submit', this.onSubmit);
        if (this.result && Date.now() - this.readPending() < 3600000) {
          this.dialog.showModal();
          this.rememberSeen();
          if (this.result === 'success') this.writePending(0);
          return;
        }
        if (!this.preview && this.hasSeen()) return;
        this.timer = setTimeout(() => {
          if (this.isConnected && !this.dialog.open && (this.preview || !this.hasSeen())) {
            this.dialog.showModal();
            this.rememberSeen();
          }
        }, this.preview ? 100 : Number(this.dataset.delay) || 2000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.removeEventListener('click', this.onCloseClick);
        this.dialog.removeEventListener('click', this.onBackdrop);
        this.form.removeEventListener('submit', this.onSubmit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aara-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aara-whatsapp')) {
    customElements.define('aara-whatsapp', class extends HTMLElement {
      connectedCallback() {
        this.normalizeLink = (link) => {
          if (!link) return;
          try {
            const url = new URL(link.href, document.baseURI);
            const directChat = url.hostname === 'wa.me' && /^\/[0-9]+\/?$/.test(url.pathname);
            const sendChat = ['api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname) && url.pathname === '/send';
            if (!directChat && !sendChat) return;
            url.searchParams.set('text', this.dataset.message);
            link.href = url.toString();
          } catch {}
        };
        this.normalizeLinks = () => document.querySelectorAll('a[href]').forEach(this.normalizeLink);
        this.onChatClick = (event) => this.normalizeLink(event.target.closest('a[href]'));
        this.normalizeLinks();
        document.addEventListener('click', this.onChatClick, true);
        document.addEventListener('shopify:section:load', this.normalizeLinks);
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.closeButton = this.querySelector('.aara-whatsapp__close');
        this.close = () => {
          this.details.open = false;
          this.summary.setAttribute('aria-expanded', 'false');
          this.summary.focus();
        };
        this.onKey = (event) => {
          if (event.key === 'Escape' && this.details.open) this.close();
        };
        this.onOutside = (event) => {
          if (!this.contains(event.target) && this.details.open) {
            this.details.open = false;
            this.summary.setAttribute('aria-expanded', 'false');
          }
        };
        this.onToggle = () => this.summary.setAttribute('aria-expanded', String(this.details.open));
        this.closeButton.addEventListener('click', this.close);
        this.details.addEventListener('toggle', this.onToggle);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('pointerdown', this.onOutside);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onChatClick, true);
        document.removeEventListener('shopify:section:load', this.normalizeLinks);
        this.closeButton.removeEventListener('click', this.close);
        this.details.removeEventListener('toggle', this.onToggle);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('pointerdown', this.onOutside);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
